export const TUTORIAL_DISMISSED_COOKIE = 'inkvoyd_artist_tutorial_dismissed';

type CookieOptions = {
  days?: number;
  path?: string;
  sameSite?: 'Lax' | 'Strict' | 'None';
};

const readCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;

  const encodedName = encodeURIComponent(name);
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const [rawKey, ...rawValue] = part.trim().split('=');
    if (!rawKey) continue;
    if (rawKey === encodedName) {
      return decodeURIComponent(rawValue.join('='));
    }
  }
  return null;
};

const writeCookie = (name: string, value: string, options: CookieOptions = {}) => {
  if (typeof document === 'undefined') return;

  const days = options.days ?? 365;
  const path = options.path ?? '/';
  const sameSite = options.sameSite ?? 'Lax';

  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Expires=${expires.toUTCString()}; Path=${path}; SameSite=${sameSite}`;
  if (typeof window !== 'undefined' && window.location?.protocol === 'https:') {
    cookie += '; Secure';
  }

  document.cookie = cookie;
};

export const isArtistTutorialDismissed = (): boolean => {
  return readCookie(TUTORIAL_DISMISSED_COOKIE) === '1';
};

export const dismissArtistTutorial = (days = 365) => {
  writeCookie(TUTORIAL_DISMISSED_COOKIE, '1', { days, sameSite: 'Lax', path: '/' });
};
